// 引入axios方法
import { fun_PostAction } from "@/api/index";
import axios from "@/api/request.js";
// 引入加密方法
import "@/utils/security.js";
import { fun_GetKeys } from "@/utils/validate";
export default {
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 加密key
      key: null,
      // 加密提交值
      code: null,
      // 弹窗
      dialogVisible: false,
      count: 10,
      flag: false,
      regShow: "1",
      isClick: false,
      timer: null,
      licensePathFile: null,
      address: null,
      photoName: "",
      codeImgSrc: null,
      yzCodeImgSrc: null,
      // 中招扫码对象
      interlink: {
        // 定时任务对象
        intervalTime: null,
        // 二维码时效
        timeout: null,
        // tid
        tid: null,
        // 二维码内容
        QRCodeContent: null,
        // 扫码信息
        qrCode: null
      },
      // 中招二维码参数
      invalidParam: {
        // 图片路径
        imgUrl: null,
        // logo地址
        logo: require("@/assets/images/zzLogo.png")
      },
      // 默认不显示中招失效二维码
      invalidQRCode: false,
      form: {
        exponent: null, // 加密exponent参数
        modulus: null, // 加密modulus参数
        yhzwmc: null, // 企业中文名称
        yhlx: null, // 机构类型
        corpType: null, // 机构类型
        yhmc: null, // 登录名称
        yhmm: null, // 用户密码
        yhmmqr: null, // 用户密码确认
        yhdm: null, // 统一社会信用代码
        licensePath: null, // 营业执照
        zoneCode: null, // 划区
        legalName: null, // 法人姓名
        postCode: null, // 邮政编码
        corpProducts: null, // 企业主营产品
        licenseValidity: null, // 执照有效日期
        registeredCapital: null, // 注册资本
        currency: null, // 币种
        regLevel: null, // 注册级别
        regAddress: null, // 注册地址
        // regType: null, // 企业登记注册类型
        remarks: null, // 备注
        linkName: null, // 姓名
        linkTel: null, // 电话
        linkPhone: null, // 手机
        linkDuty: null, // 职务
        qq: null, // 传真
        lxrdzyx: null, // 邮箱
        linkAddress: null, // 联系地址
        bankName: null, // 开户行
        bankCode: null, // 开户号
        licensePathFile: null,
        checked: null, // 是否勾选
        mimeCodeYZ: null, //验证用户名验证码
        mimeCode: null, //验证码
        idCard: null, //身份证
        legalCode: null, // 组织机构代码
        t: null
      },
      errRules: {
        yhzwmc: null, // 企业中文名称
        yhlx: null, // 机构类型
        corpType: null, // 机构类型
        yhmc: null, // 登录名称
        yhmm: null, // 用户密码
        yhdm: null, // 统一社会信用代码
        licensePath: null, // 营业执照
        zoneCode: null, // 划区
        legalName: null, // 法人姓名
        postCode: null, // 邮政编码
        corpProducts: null, // 企业主营产品
        licenseValidity: null, // 执照有效日期
        registeredCapital: null, // 注册资本
        currency: null, // 币种
        regLevel: null, // 注册级别
        regAddress: null, // 注册地址
        // regType: null, // 企业登记注册类型
        remarks: null, // 备注
        linkName: null, // 姓名
        linkTel: null, // 电话
        linkPhone: null, // 手机
        linkDuty: null, // 职务
        qq: null, // 传真
        lxrdzyx: null, // 邮箱
        linkAddress: null, // 联系地址
        bankName: null, // 开户行
        bankCode: null, // 开户号
        licensePathFile: null,
        checked: null, // 是否勾选
        mimeCodeYZ: null, //验证用户名验证码
        mimeCode: null, //验证码
        t: null
      },
      formConfigList: [
        {
          label: "用户类型：",
          value: "yhlx",
          type: "slot",
          slotName: "yhlx",
          required: true,
          clearable: true,
          multipleValue: true,
          rule: {
            required: true,
            message: "请选择用户类型",
            trigger: "blur"
          }
        },
        {
          label: "用户代码：",
          value: "yhdm",
          type: "input",
          maxlength: 20,
          placeholder: "企业填写组织机构代码，项目负责人填写身份证号",
          tip: "企业填写组织机构代码，项目负责人填写身份证号",
          required: true,
          rule: [
            {
              required: true,
              message: "请输入用户代码",
              trigger: "blur"
            },
            {
              pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
              message: "请输入正确的用户代码"
            }
          ]
        },
        {
          label: "登录名：",
          value: "yhmc",
          type: "input",
          maxlength: 20,
          placeholder: "请输入字母、数字及'-' '_' 的任意组合",
          tip: "请输入字母、数字及'-' '_' 的任意组合",
          class: "yhmc",
          required: true,
          rule: {
            required: true,
            message: "请输入登录名",
            trigger: "blur"
          }
        },
        {
          label: "",
          value: "mimeCodeYZ",
          type: "slot",
          slotName: "mimeCodeYZ",
          required: true,
          class: "yhYzm",
          rule: {
            required: true,
            message: "请填写",
            trigger: "blur"
          }
        },
        // {
        //   label: "登录名：",
        //   value: "yhmc",
        //   type: "slot",
        //   slotName: "yhmc",
        //   required: true,
        //   rule: {
        //     required: true,
        //     message: "请输入登录名",
        //     trigger: "blur"
        //   }
        // },
        {
          label: "用户中文名称：",
          value: "yhzwmc",
          type: "input",
          maxlength: 25,
          placeholder: "长度只能在4-25位字符之间",
          required: true,
          rule: [
            {
              required: true,
              message: "请输入用户中文名称",
              trigger: "blur"
            }
          ]
        },
        {
          label: "联系人电子邮箱：",
          value: "lxrdzyx",
          maxlength: 50,
          type: "input",
          placeholder: "请填写",
          required: true,
          rule: {
            required: true,
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "请输入格式正确的邮箱"
          }
        },
        {
          label: "用户密码：",
          value: "yhmm",
          type: "password",
          maxlength: 20,
          placeholder: "可输入8-20个字符",
          required: true,
          rule: [
            {
              required: true,
              message: "请输入密码",
              trigger: "blur"
            },
            {
              pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z_!@#$^&~.]+$)(?![a-z0-9]+$)(?![a-z_!@#$^&~.]+$)(?![0-9_!@#$^&~.]+$)[a-zA-Z0-9_!@#$^&~.]{8,20}$/,
              message:
                "请至少输入8个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种"
            }
          ]
        },
        {
          label: "密码确认：",
          value: "yhmmqr",
          type: "password",
          maxlength: 20,
          placeholder: "可输入8-20个字符",
          required: true,
          rule: [
            {
              required: true,
              message: "请输入密码",
              trigger: "blur"
            },
            {
              pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z_!@#$^&~.]+$)(?![a-z0-9]+$)(?![a-z_!@#$^&~.]+$)(?![0-9_!@#$^&~.]+$)[a-zA-Z0-9_!@#$^&~.]{8,20}$/,
              message:
                "请至少输入8个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种"
            }
          ]
        },
        {
          label: "验证码",
          value: "mimeCode",
          type: "slot",
          slotName: "mimeCode",
          required: true,
          rule: {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        },
        {
          type: "slot",
          slotName: "checkbox"
        },
        {
          type: "slot",
          slotName: "tit",
          class: "tipsCont"
        },
        {
          type: "slot",
          slotName: "btn"
        }
      ],
      // 用户类型选择数据
      options: [
        {
          label: "...",
          value: ""
        },
        {
          label: "企业（市场主体）",
          value: "201508061647340018"
        },
        {
          label: "项目负责人",
          value: "201508061647510026"
        }
      ],
      pickerOptions: {
        disabledDate(time) {
          // 设置可选择的日期为今天之后的一个月内
          let curDate = new Date().getTime();
          let day = 24 * 60 * 60 * 1000;
          let dateRegion = curDate - day;
          return time.getTime() < dateRegion;
        }
      },
      // 注册步骤
      stepList: [
        {
          num: "1",
          text: "阅读用户协议",
          line: true
        },
        {
          num: "2",
          text: "填写注册信息",
          line: true
        },
        {
          num: "3",
          text: "用户注册完成",
          line: false
        }
      ],
      // 注册成功标识
      isReg: false
    };
  },
  // 模板编译完成
  mounted() {
    // 调用验证码方法
    this.fun_GetCode("0");
    // 调用验证码方法
    this.fun_GetCode("1");
    // 获取加密key
    this.fun_GetRSAKey();
    // 初始化参数
    this.fun_GetInit();
  },
  methods: {
    /**
     * 获取初始化参数接口
     * @author 滕威
     */
    fun_GetInit() {
      // 调用获取加密参数接口
      fun_PostAction("/foregroundUser/init").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取exponent
          this.form.exponent = data.exponent;
          // 获取modulus
          this.form.modulus = data.modulus;
        }
      });
    },

    /**
     * 获取验证码接口
     * @author 滕威
     */
    fun_GetCode(type) {
      // 获取随机数
      this.form.t = new Date().getTime() + Math.random();
      if (type == "0") {
        // 获取验证码
        this.yzCodeImgSrc = `/brs-server/mime?t=${this.form.t}` + "&flag=2";
      } else {
        // 获取验证码
        this.codeImgSrc = `/brs-server/mime?t=${this.form.t}` + "&flag=0";
      }
    },

    /**
     * 下拉框选择事件
     * @params e 选择的value值
     * @author 滕威
     */
    fun_GetSelectVal(e, val) {
      // 遍历查询表单对象
      for (const key in this.form) {
        // 判断key和val是否相同
        if (key == val) {
          // 相同则复制给表单
          this.form[key] = e;
        }
      }
    },
    /**
     * 中招扫码注册
     */
    fun_GetCa() {
      // 打开弹窗
      this.dialogVisible = true;
      // 刷新中招扫码
      this.fun_RefLinkCode();
    },
    /**
     * @author 滕威
     * @description 同意
     */
    fun_Agree() {
      this.flag = true;
      const that = this;
      // 判断是否重新点击
      if (!this.isClick) {
        this.isClick = true;
        this.time = setInterval(function() {
          that.count--;
          if (that.count === 0) {
            that.regShow = "2";
            clearInterval(that.time);
          }
        }, 1000);
      }
    },
    /**
     * @author 滕威
     * @description 放弃
     */
    fun_Pass() {
      clearInterval(this.time);
      this.$router.push({ path: "/" });
    },

    /**
     * 获取加密key接口
     * @author 滕威
     */
    fun_GetRSAKey() {
      // 调用获取加密参数接口
      fun_PostAction("/getRSAKey").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取加密key
          this.key = window.RSAUtils.getKeyPair(
            data.exponent,
            "",
            data.modulus
          );
        }
      });
    },

    /**
     * 页面验证唯一性
     */
    fun_RegistryCheckUser(bclx) {
      // 用户类型为项目负责人
      if (this.form.yhlx == "201508061647510026") {
        this.form.idCard = this.form.yhdm;
        this.form.legalCode = null;
      }
      // 用户类型为企业
      else {
        this.form.idCard = null;
        this.form.legalCode = this.form.yhdm;
      }

      // 清除表单验证错误信息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // 打开遮罩
      this.loading = true;
      // 验证标记
      var flag = false;
      // 保存类型是保存的场合
      if (bclx == "save") {
        // 校验
        this.$refs.form.$refs.enInform.validate(valid => {
          // 验证通过
          if (valid) {
            // 设置为true
            flag = true;
          }
        });
      } else {
        //  如果用户类型和登录名为空
        if (
          this.form.yhlx == "" ||
          this.form.yhlx == null ||
          this.form.yhmc == "" ||
          this.form.yhmc == null
        ) {
          this.errRules.yhlx = "该输入项不能为空！";
          this.errRules.yhmc = "该输入项不能为空！";
        } else {
          var mimeCode = window.RSAUtils.encryptedString(
            this.key,
            this.form.mimeCodeYZ
          );
          // 发起请求
          fun_PostAction("/foregroundUser/registryCheckUser", {
            bclx: bclx,
            YZflag: "1",
            code: mimeCode,
            mimeCodeYZ: this.form.mimeCodeYZ
          }).then(res => {
            // 结构res.data
            const { result, data, msg } = res.data;
            // 请求成功
            if (result) {
              if (data.result == "false") {
                // 关闭遮罩层
                this.loading = false;
                // 获取错误消息
                var errMsg = data.errMsg;
                // 判断错误消息是否为空
                if (errMsg != "" && errMsg != null) {
                  // 提示错误
                  this.$alert(errMsg, "warning");
                } else {
                  // 提示错误
                  this.$alert("保存失败！", "warning");
                }
              } else {
                // 发起请求
                fun_PostAction("/foregroundUser/registryCheckUser", {
                  bclx: bclx,
                  YZflag: "2",
                  yhmc: encodeURI(this.form.yhmc),
                  yhlx: this.form.corpType,
                  code: mimeCode,
                  mimeCodeYZ: this.form.mimeCodeYZ
                }).then(res => {
                  // 结构res.data
                  const { result, data, msg } = res.data;
                  // 请求成功
                  if (result) {
                    // 关闭遮罩层
                    this.loading = false;
                    // 获取回调函数
                    this.fun_GetResponse(data);
                  } else {
                    // 关闭遮罩层
                    this.loading = false;
                    // 提示请求失败的信息
                    this.$message.error(msg);
                  }
                });
              }
            } else {
              // 关闭遮罩层
              this.loading = false;
              // 提示请求失败的信息
              this.$message.error(msg);
            }
          });
        }
      }
      if (flag == true) {
        // 发起请求
        fun_PostAction("/foregroundUser/registryCheckUser", {
          bclx: bclx,
          YZflag: "2",
          yhmc: encodeURI(this.form.yhmc),
          yhlx: this.form.yhlx,
          idCard: this.form.idCard,
          legalCode: this.form.legalCode,
          yhzwmc: this.form.yhzwmc,
          legalRepresent: this.form.legalRepresent,
          legalIDCard: this.form.legalIDCard,
          telephoneNum: this.form.telephoneNum,
          yhdm: this.form.yhdm
        }).then(res => {
          // 结构res.data
          const { result, data, msg } = res.data;
          // 请求成功
          if (result) {
            // 关闭遮罩层
            this.loading = false;
            // 获取回调函数
            this.fun_GetResponse(data);
          } else {
            // 关闭遮罩层
            this.loading = false;
            // 提示请求失败的信息
            this.$message.error(msg);
          }
        });
      }
    },

    /**
     * Ajax回调函数
     * @param httpObj 字符流
     */
    fun_GetResponse(data) {
      // 操作成功的场合
      if (data.result != null && data.result != "") {
        // 保存成功的场合
        if (data.result == "false") {
          // 错误消息不为空
          if (data.errMsg != "") {
            // 错误消息为
            if (
              data.errMsg == "用户已存在账号，是否由省主体库直接同步用户信息？"
            ) {
              // 回显错误
              this.errRules.yhdm = data.errMsg;
              // 弹出询问confirm
              this.$confirm(
                "用户已存在账号，是否由省主体库直接同步用户信息？",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                }
              ).then(() => {
                // 同步用户信息
                this.fun_SyncUserInfo();
              });
            } else {
              if (data.checkUserName == "false") {
                // 提示错误
                this.$alert(data.errMsg, "err");
                // 回显错误
                this.errRules.yhmc = data.errMsg;
              } else {
                // 提示错误
                this.$alert(data.errMsg, "err");
                // 回显错误
                this.errRules.yhdm = data.errMsg;
              }
            }
          } else {
            // 提示错误
            this.$alert("查询失败！", "err");
          }
        } else {
          if (data.rtnMsg != "") {
            if (data.rtnMsg == "save") {
              this.fun_InsUpd();
            } else {
              // 提示错误
              this.$alert(data.rtnMsg, "warning");
            }
          } else {
            // 提示错误
            this.$alert("查询失败！", "err");
          }
        }
      }
    },

    fun_InsUpd() {
      // 如果密码和确认密码不一致
      if (this.form.yhmm != this.form.yhmmqr) {
        // 提示请求失败的信息
        this.$message.error("两次密码输入不一致！");
        return;
      }
      // 弹出询问confirm
      this.$confirm("是否注册?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 密码加密
        var yhmm = window.RSAUtils.encryptedString(this.key, this.form.yhmm);
        // 1.登录名
        var yhmc = window.RSAUtils.encryptedString(
          this.key,
          encodeURIComponent(this.form.yhmc)
        );
        // 2.联系人电子邮箱
        var lxrdzyx = window.RSAUtils.encryptedString(
          this.key,
          this.form.lxrdzyx
        );
        // 3.验证码
        var mimeCode = window.RSAUtils.encryptedString(
          this.key,
          this.form.mimeCode
        );
        this.code = yhmc + ";" + lxrdzyx + ";" + mimeCode;
        // 发起请求
        fun_PostAction("/foregroundUser/insUpd", {
          YZflag: "1",
          ...this.form,
          code: this.code,
          mimeCode: this.form.mimeCode,
          mimeCodeYZ: this.form.mimeCodeYZ,
          yhmm: yhmm
        }).then(res => {
          // 结构res.data
          const { result, data, msg } = res.data;
          // 请求成功
          if (result) {
            // 注册成功标识
            this.regShow = "3";
            // 关闭遮罩层
            this.loading = false;
            // 操作成功
            this.$message.success(msg);
          } else {
            // 关闭遮罩层
            this.loading = false;
            // 提示请求失败的信息
            this.$message.error(msg);
          }
        });
      });
    },

    /**
     * 获取二维码内容（中招互联）
     */
    fun_GetQRCodeContent() {
      // 清空
      // 用户类型
      this.form.yhlx = "";
      // 用户中文名称
      this.form.yhzwmc = "";
      // 访问接口
      fun_PostAction("/interlink/getQRCodeContent").then(res => {
        const { data, result } = res.data;
        if (result) {
          // 二维码code
          this.interlink.qrCode = data.qrCode;
          // 请求二维码tid
          this.interlink.tid = data.tid;
          // 二维码内容
          this.interlink.QRCodeContent = data.content;
          // 请求二维码
          this.invalidParam.imgUrl =
            "/whebd-server/interlink/getLoginQRCode?content=" + data.content;
          // 如果二维码不为空
          if (this.invalidParam.imgUrl) {
            // 设置定时任务检验扫码状态
            this.interlink.intervalTime = setInterval(() => {
              // 校验扫码状态
              this.fun_CheckQRCodeStatus();
            }, data.codeFlushTime);
            // 定时执行时效任务，30秒二维码时效
            this.interlink.timeout = setTimeout(() => {
              this.fun_SetFileQRCodeImage();
            }, data.codeFailTime);
          }
        }
      });
    },

    /**
     * 校验扫码状态（中招互联）
     */
    fun_CheckQRCodeStatus() {
      // 访问接口
      fun_PostAction("/interlink/loginQRCode", {
        tId: this.interlink.tid
      }).then(res => {
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          console.log(data);
          var json = JSON.parse(data);
          // 返回数据不为空
          if (json.idCard) {
            // 停止定时任务
            clearInterval(this.interlink.intervalTime);
            // 停止二维码失效任务
            clearTimeout(this.interlink.timeout);
            // 如果legalCode不为空, 则为企业用户
            if (json.legalCode) {
              // 设置成企业
              this.fun_SelectChange("201508061647340018");
              // 赋值
              // 用户类型为企业用户
              this.form.yhlx = "201508061647340018";
              // 用户中文名称
              this.form.yhzwmc = json.legalName;
              // 社会信用代码
              this.form.yhdm = json.legalCode;
              // 关闭二维码
              this.dialogVisible = false;
            } else {
              // 设置成个人
              this.fun_SelectChange("201508061647510026");
              // 赋值
              // 用户类型为个人用户
              this.form.yhlx = "201508061647510026";
              // 用户中文名称
              this.form.yhzwmc = json.personName;
              // 社会信用代码
              this.form.yhdm = json.idCard;
              // 关闭二维码
              this.dialogVisible = false;
            }
          }
        }
      });
    },

    /**
     * 失效二维码
     */
    fun_SetFileQRCodeImage() {
      // 显示失效二维码
      this.invalidQRCode = true;
      // 取消定时任务
      this.fun_ClearInter();
    },

    /**
     * 刷新中招二维码
     */
    fun_RefLinkCode() {
      // 关闭失效图片
      this.invalidQRCode = false;
      // 清空定时任务
      this.fun_ClearInter();
      // 生成二维码
      this.fun_GetQRCodeContent();
    },

    /**
     * 取消定时任务
     * @author zhouzhou
     */
    fun_ClearInter() {
      // 停止定时任务
      clearInterval(this.interlink.intervalTime);
      // 停止二维码失效任务
      clearTimeout(this.interlink.timeout);
    },
    /**
     * 返回登录
     */
    fun_BackLogin() {
      // 跳转登录
      this.$router.push("/");
    },

    /**
     * 下拉框选择事件
     */
    fun_SelectChange(e) {
      // 企业
      if (e === "201508061647340018" || e == "" || e == null) {
        this.formConfigList = [
          {
            label: "用户类型：",
            value: "yhlx",
            type: "slot",
            slotName: "yhlx",
            required: true,
            clearable: true,
            multipleValue: true,
            rule: {
              required: true,
              message: "请选择用户类型",
              trigger: "blur"
            }
          },
          {
            label: "用户代码：",
            value: "yhdm",
            type: "input",
            maxlength: 20,
            placeholder: "企业填写组织机构代码",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入统一社会信用代码",
                trigger: "blur"
              },
              {
                pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
                message: "请输入正确的社会信用代码"
              }
            ]
          },
          {
            label: "登录名：",
            value: "yhmc",
            type: "input",
            maxlength: 20,
            placeholder: "请输入字母、数字及'-' '_' 的组合",
            tip: "请输入字母、数字及'-' '_' 的组合",
            class: "yhmc",
            required: true,
            rule: {
              required: true,
              message: "请输入登录名",
              trigger: "blur"
            }
          },
          {
            label: "",
            value: "mimeCodeYZ",
            type: "slot",
            slotName: "mimeCodeYZ",
            required: true,
            class: "yhYzm",
            rule: {
              required: true,
              message: "请填写",
              trigger: "blur"
            }
          },
          {
            label: "用户中文名称：",
            value: "yhzwmc",
            type: "input",
            maxlength: 25,
            placeholder: "长度只能在4-25位字符之间",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入企业中文名称",
                trigger: "blur"
              }
            ]
          },
          {
            label: "联系人电子邮箱：",
            value: "lxrdzyx",
            maxlength: 100,
            type: "input",
            placeholder: "请填写",
            required: true,
            rule: {
              required: true,
              pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
              message: "请输入格式正确的邮箱"
            }
          },
          {
            label: "用户密码：",
            value: "yhmm",
            type: "password",
            maxlength: 20,
            placeholder: "可输入8-20个字符",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入密码",
                trigger: "blur"
              },
              {
                pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z_!@#$^&~.]+$)(?![a-z0-9]+$)(?![a-z_!@#$^&~.]+$)(?![0-9_!@#$^&~.]+$)[a-zA-Z0-9_!@#$^&~.]{8,20}$/,
                message:
                  "请至少输入8个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种"
              }
            ]
          },
          {
            label: "密码确认：",
            value: "yhmmqr",
            type: "password",
            maxlength: 20,
            placeholder: "可输入8-20个字符",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入密码",
                trigger: "blur"
              },
              {
                pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z_!@#$^&~.]+$)(?![a-z0-9]+$)(?![a-z_!@#$^&~.]+$)(?![0-9_!@#$^&~.]+$)[a-zA-Z0-9_!@#$^&~.]{8,20}$/,
                message:
                  "请至少输入8个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种"
              }
            ]
          },
          {
            label: "验证码",
            value: "mimeCode",
            type: "slot",
            slotName: "mimeCode",
            required: true,
            rule: {
              required: true,
              message: "请输入验证码",
              trigger: "blur"
            }
          },
          {
            type: "slot",
            slotName: "checkbox"
          },
          {
            type: "slot",
            slotName: "tit",
            class: "tipsCont"
          },
          {
            type: "slot",
            slotName: "btn"
          }
        ];
      }
      // 负责人
      else {
        this.formConfigList = [
          {
            label: "用户类型：",
            value: "yhlx",
            type: "slot",
            slotName: "yhlx",
            required: true,
            clearable: true,
            multipleValue: true,
            rule: {
              required: true,
              message: "请选择用户类型",
              trigger: "blur"
            }
          },
          {
            label: "用户代码：",
            value: "yhdm",
            type: "input",
            maxlength: 20,
            placeholder: "项目负责人填写身份证号",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入项目负责人填写身份证号",
                trigger: "blur"
              }
            ]
          },
          {
            label: "登录名：",
            value: "yhmc",
            type: "input",
            maxlength: 20,
            placeholder: "请输入字母、数字及'-' '_' 的组合",
            tip: "请输入字母、数字及'-' '_' 的组合",
            class: "yhmc",
            required: true,
            rule: {
              required: true,
              message: "请输入登录名",
              trigger: "blur"
            }
          },
          {
            label: "",
            value: "mimeCodeYZ",
            type: "slot",
            slotName: "mimeCodeYZ",
            required: true,
            class: "yhYzm",
            rule: {
              required: true,
              message: "请填写",
              trigger: "blur"
            }
          },
          {
            label: "用户中文名称：",
            value: "yhzwmc",
            type: "input",
            maxlength: 25,
            placeholder: "长度只能在4-25位字符之间",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入用户中文名称",
                trigger: "blur"
              }
            ]
          },
          {
            label: "联系人电子邮箱：",
            value: "lxrdzyx",
            maxlength: 100,
            type: "input",
            placeholder: "请填写",
            required: true,
            rule: {
              required: true,
              pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
              message: "请输入格式正确的邮箱"
            }
          },
          {
            label: "用户密码：",
            value: "yhmm",
            type: "password",
            maxlength: 20,
            placeholder: "可输入8-20个字符",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入密码",
                trigger: "blur"
              },
              {
                pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z_!@#$^&~.]+$)(?![a-z0-9]+$)(?![a-z_!@#$^&~.]+$)(?![0-9_!@#$^&~.]+$)[a-zA-Z0-9_!@#$^&~.]{8,20}$/,
                message:
                  "请至少输入8个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种"
              }
            ]
          },
          {
            label: "密码确认：",
            value: "yhmmqr",
            type: "password",
            maxlength: 20,
            placeholder: "可输入8-20个字符",
            required: true,
            rule: [
              {
                required: true,
                message: "请输入密码",
                trigger: "blur"
              },
              {
                pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z_!@#$^&~.]+$)(?![a-z0-9]+$)(?![a-z_!@#$^&~.]+$)(?![0-9_!@#$^&~.]+$)[a-zA-Z0-9_!@#$^&~.]{8,20}$/,
                message:
                  "请至少输入8个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种"
              }
            ]
          },
          {
            label: "验证码",
            value: "mimeCode",
            type: "slot",
            slotName: "mimeCode",
            required: true,
            rule: {
              required: true,
              message: "请输入验证码",
              trigger: "blur"
            }
          },
          {
            type: "slot",
            slotName: "checkbox"
          },
          {
            type: "slot",
            slotName: "tit",
            class: "tipsCont"
          },
          {
            type: "slot",
            slotName: "btn"
          }
        ];
      }
      // 清除表单验证和数据
      this.$refs.form.$refs.enInform.resetFields();
      // 赋值
      this.form.yhlx = e;
    },
    // 二维码弹出框关闭事件
    fun_Close() {
      // 关闭失效图片
      this.invalidQRCode = false;
      // 清空定时任务
      this.fun_ClearInter();
    },
    // 同步账号
    fun_SyncUserInfo() {
      // 发起请求，获取结果集
      fun_PostAction("/userLogin/syncUserInfo", {
        userCode: this.form.yhdm
      }).then(res => {
        // 解构res.data
        const { result, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 提示删除成功
          this.$message.success(msg);
        } else {
          // 请求失败，提示信息
          this.$message.error(msg);
        }
        // 加载框取消
        this.fullLoading.close();
      });
    }
  }
};
